// extracted by mini-css-extract-plugin
export default {"page":"Header_page__DwokH","container":"Header_container__KlHqa","summary":"Header_summary__AraYS","btn":"Header_btn__koqJg","img-box":"Header_img-box__ukQPd"};